import React  from 'react';  

export const medicalRecordsConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/medical-records',
        component: React.lazy(() => import('./PatientRecords')),
      },
    ],
  }
];